import routes from '@/config/routes';
import { v3Get } from '@/api/axios.instance.V3';
import type { ApiResponse } from '../types';

const getRosterUserListByClient = (clientId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.permissionAdmin.getRosterUserPermissionList}/${clientId}/users/list`);

export const serviceUserPermissionAdminApi = {
  getRosterUserListByClient,
};
